import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllActivityLogs } from 'actions/ReportActions';
import LegacyPratusTable from 'components/DesignSystems/PratusTable/LegacyPratusTable';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { startLoading } from 'reducers/loading/loading.action';
import { sanitizeHtml } from '../../utils/sanitizeHtml';

dayjs.extend(relativeTime);

export default function DiceLog() {
  const reduxDispatch = useDispatch();
  const diceActivityLogs = useSelector((state) => state.app.diceActivityLogs);

  const dataColDice = [
    {
      dataField: 'user_name',
      text: 'Name',
      sort: true,
      headerAttrs: { title: 'Sort By:' },
      attrs: { title: 'Name' },
      formatter: (cell, row) => {
        return (
          <div className="d-flex align-items-center">
            <div className="me-2 flex-shrink-0 button--icon primary rounded-circle p-0">
              <span className="weight-600 txt--sml">
                {row.user_name?.charAt(0)?.toUpperCase()}
              </span>
            </div>
            <p className="mb-0">{row.user_name}</p>
          </div>
        );
      },
    },
    {
      dataField: 'type',
      text: 'Type',
      sort: true,
      attrs: { title: 'Type' },
    },

    {
      dataField: 'created_at',
      text: 'Time',
      sort: true,
      attrs: { title: 'Time' },
      formatter: (cell, row) => {
        return <>{dayjs(row.created_at).fromNow()}</>;
      },
    },
  ];

  const expandRowDice = {
    parentClassName: 'parent-expand-tr',
    className: 'child-expand-tr',
    renderer: (row) => {
      const clean = sanitizeHtml(row.comment);
      return (
        <>
          <div className="row">
            <label className="form-label d-block">Comment</label>
            <div
              className="m-0"
              dangerouslySetInnerHTML={{ __html: clean }}
            ></div>
          </div>
        </>
      );
    },
    showExpandColumn: true,
  };

  useEffect(() => {
    reduxDispatch(startLoading());
    reduxDispatch(getAllActivityLogs());
  }, []);

  return (
    <>
      <LegacyPratusTable
        keyField={'id'}
        columns={dataColDice}
        rows={diceActivityLogs}
        expandRow={expandRowDice}
        hasPagination={true}
        paginationPerPageItem="10"
      />
    </>
  );
}
